import React, {useState, useEffect} from "react";

import {Grid, Typography} from "@mui/material";
import {connect} from "react-redux";
import {
    getLocationTypeOptions,
    getSortedLocations,
    setFunction
} from "../../../function.actions";
import {CompPartitionHeader} from "../../../../../components/PartitionHeader";
import {useTranslation} from "react-i18next";
import { CompDropdownNew } from "../../../../../components/newComponents/DropdownNew";
import { CompTextFieldNew } from "../../../../../components/newComponents/TextField";
import {CompCheckbox} from "../../../../../components/Checkbox";
import {getOrganizations} from "../../../../../components/organizationUtils";
import { SearchDropdownNew } from "../../../../../components/newComponents/SearchableDropdownNew";

const FunctionOrganizationAndLocationComponent = (props) => {
    const {
        fieldErrors = {},
        editorActivated,
        authenticatedUser,
        setFunction,
        organizationTree,
        selectedFunction,
        locations,
        action,
        locationTypes,
        municipalities
    } = props;

    const {t} = useTranslation('translation');

    const [organizationList, setOrganizationList] = useState([]);
    const disableAll = !editorActivated || action === "share";
    const shared = action === "share";
    const hasLocationId = selectedFunction && 'locationId' in selectedFunction;

    const isRandomChecked = action === "new" || !hasLocationId
        ? [-1, "-1"].includes(selectedFunction?.locationId) 
        : [null, -1, "-1"].includes(selectedFunction?.locationId);

    const randomLocationChoice = [
        {
            label: t('function.random_location'),
            key: "random_location",
            value: selectedFunction.random_location
        }
    ]

    const handleMultiselectChange = (event) => {
        const isChecked = event.target.checked;

        let funcData = {
            ...selectedFunction,
            random_location: isChecked,
        };

        if (isChecked) {
            funcData = {
                ...funcData,
                locationId: -1,
                locationName: "",
                locationPostCode: "",
                locationTypeId: "",
            };
        } else {
            funcData = {
                ...funcData,
                locationId: "",
            };
        }
        
        setFunction(funcData);
    };

    useEffect(() => {
        setOrganizationList(getOrganizations(organizationTree));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationTree])


    const onLocationTypeSelectionChange = event => {
        const funcData = {...selectedFunction};
        funcData.locationTypeId = event.target.value === "" ? null : event.target.value;
        setFunction(funcData);
    }

    const onLocationSelectionChange = event => {
        if (event.target.value === "") {
            const funcData = {...selectedFunction};
            funcData.locationId = null;
            funcData.locationName = "";
            funcData.locationPostCode = "";
            funcData.locationTypeId = "";
            funcData.random_location = false;
            setFunction(funcData);
        }
        else if (event.target.value === -1) {
            const funcData = {...selectedFunction};
            funcData.locationId = -1;
            funcData.locationName = "";
            funcData.locationPostCode = "";
            funcData.locationTypeId = "";
            funcData.random_location = true;
            setFunction(funcData);

        } else {
            locations.forEach((location) => {
                if (location.id === parseInt(event.target.value)) {
                    const funcData = {...selectedFunction};
                    funcData.locationId = location.id;
                    funcData.locationName = location.name;
                    funcData.locationPostCode = location.postCode;
                    funcData.locationTypeId = location.locationTypeId;
                    funcData.random_location = false;
                    setFunction(funcData);
                }
            })
        }
    }

    const organizationOnChange = (event) => {
        const functionData = {...selectedFunction}
        functionData.organizationId = event.target.value

        setFunction(functionData);
    }

    const generalHandleChange = (event, changedData) => {
        let data = {
            ...selectedFunction,
            [event.target.name]: event.target.value
        }
        if (changedData) {
            data = {
                ...selectedFunction,
                ...changedData
            }
        }
        setFunction(data);
    }
    var forceOrganization = false;

    municipalities.forEach((municipality) => {
        if (municipality.id === selectedFunction.municipalityId && municipality.forceOrganization) {
            forceOrganization = true;
        }
    })

    return (
        <>
            <Grid className={'MuiGrid-item MuiOrg-section'} size={12} /* error={sectionHasError([
                            'locationId',
                            'locationName',
                            'locationPostCode',
                            'locationType'
                        ]) ? t('errors.has error') : null} */>
                <CompPartitionHeader text={t("function.organization_and_location")}/>
                <Typography className="org_description" variant="body2" tabIndex={0}>
                    {t("function.organization_and_location_description")}
                </Typography>
                <Grid container spacing={2} sx={{padding: "0px !important"}}>
                    <Grid size={{xs: 12, sm: 6}}>
                        <SearchDropdownNew
                            label={t('common.organization')+(forceOrganization ? "*" : "") }
                            valueColumn={"id"}
                            className={'function-dropdown-organization'}
                            labelColumn={"name"}
                            rows={organizationList}
                            hasEmptyOption={true}
                            onChange={organizationOnChange}
                            disabled={!editorActivated && !shared}
                            error={fieldErrors.organizationId}
                            name="organizationId"
                            selectedValue={selectedFunction.organizationId}
                        />

                    </Grid>
                    <Grid size={{xs: 12, sm: 6}} /* sx={{paddingLeft: "20px"}} */>
                        <SearchDropdownNew
                            label={`${t('function.location')}*`}
                            selectedValue={selectedFunction.locationId ? selectedFunction.locationId : ""}
                            rows={getSortedLocations(locations, organizationList, authenticatedUser, t('components.random_location'))}
                            name="locationId"
                            labelColumn="name"
                            className={'function-dropdown'}
                            valueColumn="id"
                            disabled={disableAll}
                            error={fieldErrors.locationId}
                            onChange={onLocationSelectionChange}
                            hasEmptyOption={false}
                        />
                    </Grid>
                    <Grid className={'location-comp-mobile'} size={{xs: 6, sm: 3}} sx={{ display: "flex", gap: "20px", width: "50% !important"}}>
                        <CompTextFieldNew
                            label={`${t('function.location_name')}*`}
                            value={selectedFunction.locationName}
                            isLabelShrink={true}
                            disabled={
                                !editorActivated ||
                                !(selectedFunction.random_location || selectedFunction.locationId === -1)
                            }
                            name="locationName"
                            error={fieldErrors.locationName}
                            onChange={generalHandleChange}
                        />
                        <CompTextFieldNew
                            label={`${t('common.post_code')}`}
                            isLabelShrink={true}
                            value={selectedFunction.locationPostCode}
                            disabled={
                                !editorActivated ||
                                !(selectedFunction.random_location || selectedFunction.locationId === -1)
                            }
                            name="locationPostCode"
                            error={fieldErrors.locationPostCode}
                            onChange={generalHandleChange}
                        />
                    </Grid>
                    <Grid className="location_type-comp" size={{xs: 12, sm: 6}}>
                        <CompDropdownNew
                            label={`${t('location.location_type')}*`}
                            selectedValue={selectedFunction.locationTypeId}
                            rows={getLocationTypeOptions(t, locationTypes)}
                            name="locationType"
                            className={'function-dropdown'}
                            labelColumn="label"
                            valueColumn="value"
                            disabled={
                                !editorActivated ||
                                !(selectedFunction.random_location || selectedFunction.locationId === -1)
                            }
                            error={fieldErrors.locationType}
                            onChange={onLocationTypeSelectionChange}
                            hasEmptyOption={false}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 6}}>
                        <CompCheckbox
                            booleanmode={true}
                            rows={randomLocationChoice}
                            selected={{ random_location: isRandomChecked }} 
                            disabled={disableAll}
                            onChange={handleMultiselectChange}
                            name="random_location"
                            className="shared location_setup"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

const mapStateToProps = (state) => {
    // return state;
    return {
        func: state.func,
        templates: state.func.templates,
        authenticatedUser: state.auth.authenticatedUser,
        selectedFunction: state.func.selectedFunction,
        organizationTree: state.municipality.organizationTree,
        locations: state.location.locations,
        locationTypes: state.root.locationTypes,
        municipalities: state.municipality.municipalities,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFunction: (data) => dispatch(setFunction(data))
    };
}

export const FunctionOrganizationAndLocationComp = connect(mapStateToProps, mapDispatchToProps)(FunctionOrganizationAndLocationComponent);
